import React from "react";
import { connect } from "react-redux";
import { Table } from "react-bootstrap";

import PresetRow from "components/PresetRow";
import LoadingSpinner from "components/LoadingSpinner";

const PresetTable = ({ packs }) => {
  if (!packs || packs.length === 0) {
    return <LoadingSpinner message="Loading Preset Packs..." />;
  }
  
  return (
    <div className="preset-table-container">
      <Table striped bordered hover variant="dark" className="preset-table">
        <tbody>
          {packs.map((preset_pack) => (
            <PresetRow key={preset_pack.id} preset_pack={preset_pack} />
          ))}
        </tbody>
      </Table>
    </div>
  );
};

const mapStateToProps = state => ({
  packs: state.packs
});

export default connect(mapStateToProps)(PresetTable);
